import { Col, Row, Typography } from "antd";
import { RECENT_PROJECT_1 } from "assets";

const RecentProjectsSection = () => {
  return (
    <section className="container recent-projects-section section-margin-top">
      <Typography.Title level={2} className="m-0">
        Our Recent Projects
      </Typography.Title>
      <div className="recent-projects-section-images">
        <Row gutter={[10, 10]}>
          {[1, 2, 3, 4, 5, 6, 7, 8].map((_, i) => (
            <Col xs={24} sm={8} lg={6} xxl={4} key={i} className="center-on-small-screen">
              <img
                className="project-image"
                alt={`recent-project-${i}`}
                src={RECENT_PROJECT_1}
              />
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default RecentProjectsSection;
